// Constantes globales de Limpack — fuente única de verdad.
//
// Antes el número de WhatsApp estaba hardcoded en 25+ archivos. Si algún día
// cambia hay que tocar todo. Acá lo centralizamos. Importar desde donde se
// necesite con:   import { WA_NUMERO, WA_TEL_DISPLAY, WA_URL_BASE } from '../../lib/constantes'

/** Número de WhatsApp comercial Limpack (formato wa.me, sin + ni espacios) */
export const WA_NUMERO = '59898610001'

/** Mismo número en formato legible Uruguay (098 610 001) */
export const WA_TEL_DISPLAY = '098 610 001'

/** Base URL de WhatsApp directo (concatenar `?text=...` si se necesita mensaje pre-armado) */
export const WA_URL_BASE = `https://wa.me/${WA_NUMERO}`

/** Helper: arma URL con texto pre-cargado (encodeURIComponent automático) */
export function waUrl(texto) {
  if (!texto) return WA_URL_BASE
  return `${WA_URL_BASE}?text=${encodeURIComponent(texto)}`
}

/** Email institucional operativo */
export const EMAIL_HOLA = 'hola@limpack.uy'

/** Dominio público */
export const DOMINIO = 'limpack.uy'
